<template>
  <v-tooltip :top="hasDirection ? false : true" v-bind="$props">
    <template v-slot:activator="{ on, attrs }">
      <span class="vizNowTooltip" v-bind="{ ...attrs, ...$attrs, ...$props }" v-on="on">
        <slot />
      </span>
    </template>

    <span>
      <slot name="text">
        {{ text }}
      </slot>
    </span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "@vue/composition-api"
import { TranslateResult } from "vue-i18n"

export default defineComponent({
  name: "Tooltip",
  props: {
    text: {
      type: [String, Object] as PropType<TranslateResult | null>,
      default: ""
    },
    color: {
      type: String,
      default: "black"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    top: {
      type: Boolean,
      default: true
    },
    right: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 500
    }
  },
  setup(props) {
    return {
      hasDirection: computed(() => {
        const { right, bottom, left } = props

        return right || bottom || left
      })
    }
  }
})
</script>
